<template>
  <v-card class="rounded-lg">
    <v-card-title>Levels References config</v-card-title>
    <v-toolbar flat color="transparent">
      <v-text-field
        v-model="search"
        :append-icon="mdiMagnify"
        label="Search"
        single-line
        hide-details>
      </v-text-field>
      <v-spacer/>
      <LevelReferencesDialog
        :open-flag="openLevelReferencesDialog"
        :item="editedItem"
        @close="close"
        @save="save"
      />
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="levels"
      :search="search"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:item.action="{ item }">
        <v-icon
          small
          class="mr-2"
          title="Edit reference"
          @click="editItem(item)"
        >
          {{ mdiPencil }}
        </v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mdiPencil, mdiMagnify } from "@mdi/js"
export default {
  components: {
    LevelReferencesDialog: () => import('../../components/dialogs/LevelReferencesDialog')
  },
  data () {
    return {
      mdiPencil,
      mdiMagnify,
      openLevelReferencesDialog: false,
      loading: true,
      levels: [],
      search: '',
      headers: [
        {
          text: 'Nmae',
          value: 'name',
          sortable: false,
        },
        {
          text: 'Total size',
          value: 'total_size',
          sortable: false,
        },
        {
          text: 'Min Room',
          value: 'min_room',
          sortable: false,
        },
        {
          text: 'Max Room',
          value: 'max_room',
          sortable: false,
        },
        {
          text: 'Avg Room',
          value: 'avg_room',
          sortable: false,
        },
        {
          text: 'Median Room',
          value: 'median_room',
          sortable: false,
        },
        {
          text: 'Rooms Quantity',
          value: 'rooms_quantity',
          sortable: false,
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false,
        }
      ],
      defaultItem: {
        name: null,
        total_size: 0,
        min_room: 0,
        max_room: 0,
        avg_room: 0,
        median_room: 0,
        rooms_quantity: 0,
        categories: []
      },
      editedItem: {
        name: null,
        total_size: 0,
        min_room: 0,
        max_room: 0,
        avg_room: 0,
        median_room: 0,
        rooms_quantity: 0,
        categories: []
      }
    }
  },
  async mounted () {
    this.loading = true
    const { data } = await this.$axios.get(
      `${this.$store.getters.projectPath}/configs/levels-references`
    ).catch(error => ({ data: { err: true, message: error.response.data } }))

    if (data.err) {
      this.$toasted.error(data.message)
    } else {
      this.levels = data
    }
    this.loading = false
  },
  methods: {
    editItem (item) {
      this.editedItem = { ...item }
      this.openLevelReferencesDialog = true
    },
    close () {
      this.openLevelReferencesDialog = false
      this.editedItem = { ...this.defaultItem }
    },
    async save (item) {
      if (item.id) {
        const { data } = await this.$axios.put(
          `${this.$store.getters.projectPath}/configs/levels-references/${item.id}`,
          {
            ...item
          }
        ).catch(error => ({ data: { err: true, message: error.response.data } }))

        if (data.err) {
          this.$toasted.error(data.message)
        } else {
          const index = this.levels.findIndex(level => level.id === item.id)
          this.$set(this.levels, index, data)
        }
      } else {
        const { data } = await this.$axios.post(
          `${this.$store.getters.projectPath}/configs/levels-references`,
          {
            ...item
          }
        ).catch(error => ({ data: { err: true, message: error.response.data } }))

        if (data.err) {
          this.$toasted.error(data.message)
        } else {
          this.levels.push(data)
        }
      }
    }
  }
}
</script>